import WebviewMessenger from './WebviewMessenger';

// Server logout already succeeded. A separate result confirms SDK cleanup.
export function finishGoogleLogout(runtime) {
    if (!WebviewMessenger.isInWebView()) return Promise.resolve('unavailable');
    if (!runtime?.capabilities?.googleLogoutResult) {
        try {
            WebviewMessenger.send({ type: 'ACCOUNT_LOGGED_OUT', provider: 'GOOGLE' });
            return Promise.resolve('legacy');
        } catch (_) {
            return Promise.resolve('error');
        }
    }
    return new Promise(resolve => {
        const requestId = `google-logout-${Date.now()}-${Math.random().toString(36).slice(2)}`;
        let finished = false;
        const finish = status => {
            if (finished) return;
            finished = true;
            clearTimeout(timer);
            unsubscribe();
            resolve(status);
        };
        const unsubscribe = WebviewMessenger.onMessage(message => {
            if (message?.type === 'ACCOUNT_LOGOUT_RESULT' && message.provider === 'GOOGLE'
                && message.requestId === requestId) finish(message.status === 'success' ? 'success' : 'error');
        });
        const timer = setTimeout(() => finish('timeout'), 8000);
        try {
            WebviewMessenger.send({ type: 'ACCOUNT_LOGGED_OUT', provider: 'GOOGLE', requestId });
        } catch (_) {
            finish('error');
        }
    });
}
